import { type MouseEvent } from 'react'
import { Image } from 'component/ui/image'
import cn from 'util/cn'
import IconPin from 'asset/icon/geo/pin_s.svg'
import { Button } from 'component/ui/button'
import IconClose from 'asset/icon/close.svg'

interface IGridItem {
  title: string
  src: string
  className?: string
  onClick?: (event: MouseEvent<HTMLDivElement>) => void
  onClose?: (event: MouseEvent<HTMLButtonElement>) => void
}

const GridItem = ({ title, src, onClick, onClose }: IGridItem) => {
  return (
    <div
      onClick={onClick}
      className={cn('relative w-[126px] h-[188px] cursor-pointer')}
    >
      {onClose && (
        <Button
          $icon={true}
          $radius={'round'}
          className='absolute top-2 right-2  bg-overlay-light size-[20px] z-10'
          onClick={onClose}
        >
          <IconClose className='fill-primary-on_primary sq-[9.5px]' />
        </Button>
      )}
      <Image
        src={src}
        alt={title}
        fill={true}
        fallback={
          <div className='flex w-full h-full justify-center items-center bg-playseeGray-gray2'>
            <IconPin className='fill-primary-on_primary sq-[24px]' />
          </div>
        }
      />
      <p className='absolute bottom-[7px] px-[6px] text-primary-on_primary text-callout line-clamp-2'>
        {title}
      </p>
    </div>
  )
}

export default GridItem
